import "./PrizeDetails.scss"
import React from "react";
import {IPrize} from "../../../../../../../models/Prize";

export const PrizeDetails: React.FC<{ prizes: IPrize[] }> = ({prizes}) => {
    return <div className="table-wrap">
        <table className="data-table">
            <thead>
            <tr>
                <th>מיקום</th>
                <th>גברים</th>
                <th>נשים</th>
            </tr>
            </thead>
            <tbody>
            {prizes?.map(prize => !!prize.nis && <tr key={`${prize.nis}-${prize.place}`}>
                <td>{(prize.place)}</td>
                <td>₪{prize.nis}</td>
                <td>₪{prize.nis}</td>
            </tr>)}

            </tbody>
        </table>
    </div>
}
